import { labelStyle, groupStyle, focusStyle } from "./fieldStyles";

const TextField = ({ formik, formClass, label, valueName, style, value }) => {
  return (
    <div style={{ ...groupStyle, ...style }}>
      <style>{focusStyle}</style>
      {label && <label htmlFor={valueName} style={labelStyle}>{label}</label>}
      <input
        id={valueName}
        className={`field-modern${formik.errors[valueName] ? " is-invalid" : ""}`}
        placeholder={label}
        type="text"
        name={valueName}
        value={value !== undefined ? value : formik.values[valueName]}
        onChange={formik.handleChange}
      />
      {formik.errors[valueName] && (
        <span style={{ fontSize: "0.75rem", color: "#c62828", marginTop: "3px" }}>{formik.errors[valueName]}</span>
      )}
    </div>
  );
};

export default TextField;
